module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.reportData.campaign) ? _c('div', {
    attrs: {
      "id": "internal-report-summary"
    }
  }, [(_vm.reportData.campaign.enablePostAnalysis && _vm.postsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "postSummary"
    }
  }, [_c('post-summary', {
    attrs: {
      "posts": _vm.postsAnalysisData,
      "defaultCols": _vm.defaultPostsAnalysisStatus,
      "campaign": _vm.reportData.campaign,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('post', 'IG Post', _vm.postsAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableReelAnalysis && _vm.reelAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "reelSummary"
    }
  }, [_c('reel-summary', {
    attrs: {
      "posts": _vm.reelAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultReelAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('reel', 'IG Reel', _vm.reelAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storyAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "storySummary"
    }
  }, [_c('story-summary', {
    attrs: {
      "posts": _vm.storyAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultStoryAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('story', 'IG Story', _vm.storyAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTikTokAnalysis && _vm.tikTokAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "tiktokSummary"
    }
  }, [_c('tiktok-summary', {
    attrs: {
      "posts": _vm.tikTokAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTikTokAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('tiktok', 'TikTok Post', _vm.tikTokAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableYoutubeAnalysis && _vm.youtubeAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "youtubeSummary"
    }
  }, [_c('youtube-summary', {
    attrs: {
      "posts": _vm.youtubeAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultYoutubeAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('youtube', 'YouTube Post', _vm.youtubeAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableFbAnalysis && _vm.fbAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "fbSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "posts": _vm.fbAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultFbAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('facebook', 'Facebook', _vm.fbAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLinkedInAnalysis && _vm.linkedInAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "linkedInSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "linkedin",
      "posts": _vm.linkedInAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLinkedInAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('linkedin', 'LinkedIn', _vm.linkedInAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableTwitterAnalysis && _vm.twitterAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "twitterSummary"
    }
  }, [_c('fb-summary', {
    attrs: {
      "summaryType": "twitter",
      "posts": _vm.twitterAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultTwitterAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        _vm.openAi('twitter', 'X (Twitter)', _vm.twitterAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableXHSAnalysis && _vm.xhsAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "xhsSummary"
    }
  }, [_c('xhs-summary', {
    attrs: {
      "posts": _vm.xhsAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultXhsAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('xhs', 'XHS', _vm.xhsAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.reportData.campaign.enableLemonAnalysis && _vm.lemonAnalysisData.length > 0) ? _c('section', {
    attrs: {
      "id": "lemonSummary"
    }
  }, [_c('lemon-summary', {
    attrs: {
      "posts": _vm.lemonAnalysisData,
      "campaign": _vm.reportData.campaign,
      "defaultCols": _vm.defaultLemonAnalysisStatus,
      "isInternalView": true
    },
    on: {
      "refreshReportInf": _vm.refreshReportInf,
      "open-analysis": function($event) {
        return _vm.openAi('lemon', 'Lemon8', _vm.lemonAnalysisData)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('table-ai-analysis-modal', {
    attrs: {
      "campaign": _vm.reportData.campaign,
      "posts": _vm.aiPosts,
      "typeKey": _vm.aiTypeKey,
      "label": _vm.aiLabel
    },
    model: {
      value: (_vm.aiDialog),
      callback: function($$v) {
        _vm.aiDialog = $$v
      },
      expression: "aiDialog"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75122d03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ReportForSummary.vue
// module id = 2201
// module chunks = 0